import React from 'react';
import { Link } from 'react-router-dom';
import { Typewriter} from 'react-simple-typewriter'
import '../styles/home.css';
import '../styles/about.css';
import pfp from '../media/rishabh.png';
function Home() {
  return (
    <div className="hero">
      <ul class="background">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
      <div className='bio'>
        <h1>Hello World ,</h1>
        <h1>I am <span className='name'>Rishabh Kumar !</span></h1>
        <h2 className='my-text1'>I'm <Typewriter
          words={['a Tech Enthusiast', 'a Coding Geek', 'a Keen Learner', 'Exploring World!']}
          loop={Infinity}
          cursor
          cursorStyle='|'
          typeSpeed={80}
          deleteSpeed={50}
          delaySpeed={1000}
        /></h2>
        <Link to="/about"><button style={{ margin: "8px 10px 8px 0" }} className="glow-on-hover" type="button">ABOUT ME</button></Link>
        <Link to="/contact"><button style={{ margin: "8px 10px 8px 0" }} className="glow-on-hover" type="button">PING ME</button></Link>

        <div className='social-media'>
          <a className='social-btn' href={"https://github.com/RishabhS21"}><i className='bx bxl-github bx-home1'></i></a>
          <a className='social-btn' href={"https://www.linkedin.com/in/rishabh-kumar-901a5a224/"}><i className='bx bxl-linkedin bx-home1'></i></a>
          <a className='social-btn' href={"https://www.facebook.com/profile.php?id=100009326008564"}><i className='bx bxl-facebook bx-home1' ></i></a>
          <a className='social-btn' href={"https://www.instagram.com/surya_21rk/"}><i className='bx bxl-instagram bx-home1'></i></a>
          <a className='social-btn' href={"mailto:rishabhkumar.iitd.cs@gmail.com"}><i className='bx bxl-gmail bx-home1'></i></a>

        </div>
      </div>
      <img src={pfp} className="img" alt="profile pic" />

    </div>
  );
}

export default Home;
